<template>
  <page-header-wrapper>
    <!-- 搜索框 -->
    <a-card style="margin-top: 24px" :bordered="false" title="分类列表">
      <div slot="extra">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
      >
        <template slot="typeid" slot-scope="typeid">
          {{ typeid == 2 ? '孵化筹备期' : '孵化期项目' }}
        </template>
        <template v-for="col in ['cate_desc', 'order']" :slot="col" slot-scope="text, record, index, expanded">
          <div :key="col">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.id, expanded)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template slot="state" slot-scope="text, record">
          <a-switch
            v-action:state
            default-checked
            :checked="record.state === 1"
            @change="value => handleChangeState(value, record.id)"
          >
            <a-icon slot="checkedChildren" type="check" />
            <a-icon slot="unCheckedChildren" type="close" />
          </a-switch>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a @click="() => handleSave(record.id)"><a-icon type="check" /> 保存</a>
              <a @click="() => handleCancel(record.id)"><a-icon type="close" /> 取消</a>
            </span>
            <span v-else>
              <a @click="() => handleEdit(record.id)" v-action:update><a-icon type="edit" /> 编辑</a>
            </span>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, category } from '@/mixins' // 引入
import { TableToolBarList, StandardFormRow } from '@/components'
const apiList = {
    getList: '/opensource/cate',
    create: '/opensource/cate/create',
    update: '/opensource/cate/'
}
const fields = ['cate_desc', 'typeid', 'order', 'state', 'created_at']
const columns = [
    {
        title: '分类名称',
        dataIndex: 'typeid',
        scopedSlots: { customRender: 'typeid' }
    },
    {
        title: '分类描述',
        dataIndex: 'cate_desc',
        scopedSlots: { customRender: 'cate_desc' }
    },
    {
        title: '创建时间',
        sorter: true,
        dataIndex: 'created_at'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
    }
]
export default {
    name: 'projectCate',
    mixins: [list, table, category], // 使用mixins
    components: {
        StandardFormRow,
        TableToolBarList
    },
    data () {
        return {
            fields,
            apiList,
            columns, // 表头
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists() // 获取分类列表
    },
    methods: {

    }
}
</script>
